/**
 * Represents a raw store transaction from the native platform.
 * This is the transaction information as received from Apple App Store or Google Play Store.
 */
export class StoreTransaction {
    constructor(transactionId, originalTransactionId, transactionTimestamp, productId, quantity, promoOfferId, purchaseToken) {
        this.transactionId = transactionId;
        this.originalTransactionId = originalTransactionId;
        this.transactionDate = transactionTimestamp ? new Date(transactionTimestamp) : undefined;
        this.productId = productId;
        this.quantity = quantity !== null && quantity !== void 0 ? quantity : 1;
        this.promoOfferId = promoOfferId;
        this.purchaseToken = purchaseToken;
    }
}
//# sourceMappingURL=StoreTransaction.js.map